<template>
    <ul class="cabinet-nav-list">
        <li
            v-tooltip="getTooltipOptions('Главная')"
            class="cabinet-nav-list__item"
        >
            <router-link
                to="/account"
                exact
                class="cabinet-nav-list__link flex flex-align-center"
                :class="{
                    active: [
                        'Supplier',
                        'SupplierGlobalSuppliers',
                        'SupplierGlobalBrands',
                        'SupplierGlobalRetailers'
                    ].includes($route.name)
                }"
            >
                <i class="cabinet-nav__icon cabinet-nav__icon--home-3"></i>
                <div class="cabinet-nav-list__link-title">Главная</div>
            </router-link>
        </li>

        <li
            v-tooltip="getTooltipOptions('Статистика')"
            class="cabinet-nav-list__item d-none d-md-block"
        >
            <router-link
                to="/account/statistics"
                class="cabinet-nav-list__link flex flex-align-center js-menu-link"
            >
                <i class="cabinet-nav__icon cabinet-nav__icon--statistics"></i>
                <div class="cabinet-nav-list__link-title">Статистика</div>
            </router-link>
        </li>

        <li
            v-tooltip="getTooltipOptions('Изделия')"
            class="cabinet-nav-list__item"
        >
            <router-link
                to="/account/products"
                href="javascript:void(0)"
                class="cabinet-nav-list__link flex flex-align-center js-menu-link"
            >
                <i class="cabinet-nav__icon cabinet-nav__icon--products"></i>
                <div class="cabinet-nav-list__link-title">Изделия</div>
            </router-link>
        </li>

        <li
            v-tooltip="getTooltipOptions('Добавить изделие')"
            class="cabinet-nav-list__item"
        >
            <router-link
                to="/account/products-add"
                class="cabinet-nav-list__link flex flex-align-center js-menu-link d-none d-md-flex"
            >
                <i
                    class="cabinet-nav__icon cabinet-nav__icon--add-product-2"
                ></i>
                <div class="cabinet-nav-list__link-title">Добавить изделие</div>
            </router-link>
            <router-link
                to="/account/products-add"
                class="cabinet-nav-list__link flex flex-align-center js-menu-link d-flex d-md-none"
            >
                <i
                    class="cabinet-nav__icon cabinet-nav__icon--add-product-2"
                ></i>
                <div class="cabinet-nav-list__link-title">Добавить</div>
            </router-link>
        </li>

        <li
            v-tooltip="getTooltipOptions('Заказы')"
            class="cabinet-nav-list__item"
        >
            <router-link
                to="/account/orders"
                class="cabinet-nav-list__link flex flex-align-center"
            >
                <i class="cabinet-nav__icon cabinet-nav__icon--order"></i>
                <div class="cabinet-nav-list__link-title">Заказы</div>
            </router-link>
        </li>

        <li
            v-tooltip="getTooltipOptions('Поставщики')"
            class="cabinet-nav-list__item cabinet-nav-list__item--orders"
        >
            <router-link
                to="/account/statistics/suppliers"
                class="cabinet-nav-list__link flex flex-align-center"
            >
                <i class="cabinet-nav__icon cabinet-nav__icon--users"></i>
                <div class="cabinet-nav-list__link-title">Поставщики</div>
            </router-link>
        </li>

        <li
            v-tooltip="getTooltipOptions('Ритейлеры')"
            class="cabinet-nav-list__item cabinet-nav-list__item--orders"
        >
            <router-link
                to="/account/statistics/retailers"
                class="cabinet-nav-list__link flex flex-align-center"
            >
                <i class="cabinet-nav__icon cabinet-nav__icon--users"></i>
                <div class="cabinet-nav-list__link-title">Ритейлеры</div>
            </router-link>
        </li>

        <li
            v-tooltip="getTooltipOptions('Маркетплейс')"
            class="cabinet-nav-list__item cabinet-nav-list__item--orders"
        >
            <router-link
                to="/"
                exact
                target="_blank"
                class="cabinet-nav-list__link flex flex-align-center"
            >
                <div class="cabinet-nav-list__link-title">Маркетплейс</div>
                <i class="cabinet-nav__icon cabinet-nav__icon--marketplace"></i>
            </router-link>
        </li>

        <li
            v-tooltip="getTooltipOptions('Ещё')"
            class="cabinet-nav-list__item d-md-none"
            @click="$emit('toggleMenu')"
        >
            <a
                v-click-outside="userSubMenuClose"
                :class="{ open: userSubMenuIsOpen }"
                href="javascript:void(0)"
                class="cabinet-nav-list__link flex flex-align-center js-dropdown-toogle"
                data-target="nav-dropdown"
                @click="userSubMenuToggle"
            >
                <i class="cabinet-nav__icon cabinet-nav__icon--ellipsis"></i>
                <div class="cabinet-nav-list__link-title">Ещё</div>
            </a>
            <div
                :class="{ open: userSubMenuIsOpen }"
                class="cabinet-nav-footer__arrow"
            ></div>

            <div
                :class="{ hide: !userSubMenuIsOpen }"
                class="app-dropdown app-dropdown--nav js-dropdown"
            >
                <div class="app-dropdown__main-menu">
                    <router-link
                        to="/account/statistics"
                        exact
                        class="cabinet-nav-list__link cabinet-nav-list__link--dropdown-menu flex flex-align-center"
                    >
                        <i
                            class="cabinet-nav__icon cabinet-nav__icon--statistics"
                        ></i>
                        <div
                            class="cabinet-nav-list__link-title cabinet-nav-list__link-title--dropdown"
                        >
                            Статистика
                        </div>
                    </router-link>
                    <router-link
                        to="/account/statistics/suppliers"
                        class="cabinet-nav-list__link cabinet-nav-list__link--dropdown-menu flex flex-align-center"
                    >
                        <i
                            class="cabinet-nav__icon cabinet-nav__icon--users"
                        ></i>
                        <div
                            class="cabinet-nav-list__link-title cabinet-nav-list__link-title--dropdown"
                        >
                            Поставщики
                        </div>
                    </router-link>
                    <router-link
                        to="/account/statistics/retailers"
                        class="cabinet-nav-list__link cabinet-nav-list__link--dropdown-menu flex flex-align-center"
                    >
                        <i
                            class="cabinet-nav__icon cabinet-nav__icon--users"
                        ></i>
                        <div
                            class="cabinet-nav-list__link-title cabinet-nav-list__link-title--dropdown"
                        >
                            Ритейлеры
                        </div>
                    </router-link>
                    <router-link
                        to="/"
                        exact
                        target="_blank"
                        class="cabinet-nav-list__link cabinet-nav-list__link--dropdown-menu flex flex-align-center"
                    >
                        <div
                            class="cabinet-nav-list__link-title cabinet-nav-list__link-title--dropdown"
                        >
                            Маркетплейс
                        </div>
                        <i
                            class="cabinet-nav__icon cabinet-nav__icon--marketplace"
                        ></i>
                    </router-link>
                </div>
                <router-link to="/account/settings" class="app-dropdown__item"
                    >Настройки аккаунта</router-link
                >

                <a href="/auth/logout" class="app-dropdown__item">
                    Выйти
                </a>
                <a
                    href="javascript:void(0)"
                    class="app-dropdown__item js-modal-toogle d-md-none"
                    @click.prevent="openModal"
                    >Помощь</a
                >
            </div>
        </li>
    </ul>
</template>

<script>
import ClickOutside from 'vue-click-outside'
import navTooltips from '@/mixins/nav-tooltips.js'
import settings from '@/settings'

export default {
    name: 'NavSupplier',
    directives: {
        ClickOutside
    },
    mixins: [navTooltips],
    data() {
        return {
            userSubMenuIsOpen: false,
            canLogout: !settings.IS_DEV_MODE
        }
    },
    methods: {
        userSubMenuToggle() {
            this.userSubMenuIsOpen = !this.userSubMenuIsOpen
        },
        userSubMenuOpen() {
            this.userSubMenuIsOpen = true
        },
        userSubMenuClose() {
            this.userSubMenuIsOpen = false
        }
    }
}
</script>
